(function () {
  var dataLayerName = 'analyzelyDataLayer';
  var debugLayerName = 'evolovaDataLayer';
  var suppressStorageKey = 'evolova_test_traffic';
  var recentEvents = {};
  var recentExplicitCartAdds = {};
  var terminalCartAttempts = {};
  var lastCart = null;
  var pendingVariantSelection = null;
  var contentSchemaVersion = 'v1';
  var pageInstanceId = createPageInstanceId();
  var contentDebugMirrorRing = [];
  var contentDebugMirrorLimit = 20;
  var contentDebugMirrorScriptId = 'evolova-analytics-debug-mirror';

  function createPageInstanceId() {
    try {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    } catch (error) {}
    return 'p_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10);
  }

  function getSanitizedPageLocation() {
    return window.location.origin + window.location.pathname;
  }

  function getSearchParams() {
    try {
      return new URLSearchParams(window.location.search || '');
    } catch (error) {
      return null;
    }
  }

  function isEnabledValue(value) {
    return /^(1|true|yes|on|internal|developer|test)$/i.test(String(value || ''));
  }

  function isDisabledValue(value) {
    return /^(0|false|no|off|live|production)$/i.test(String(value || ''));
  }

  function setSuppression(reason) {
    if (!reason) return;
    window.EVOLOVA_ANALYTICS_SUPPRESS = true;
    window.EVOLOVA_ANALYTICS_SUPPRESSION_REASON = reason;
    try {
      window.sessionStorage.setItem(suppressStorageKey, reason);
    } catch (error) {}
  }

  function clearSuppression() {
    window.EVOLOVA_ANALYTICS_SUPPRESS = false;
    window.EVOLOVA_ANALYTICS_SUPPRESSION_REASON = '';
    try {
      window.sessionStorage.removeItem(suppressStorageKey);
    } catch (error) {}
  }

	  function getSuppressionReason() {
	    var params = getSearchParams();
	    var explicitTest = params && (params.get('evo_test') || params.get('evolova_test') || params.get('ga_test') || params.get('traffic_type'));
	
	    if (isTestThemePreview()) {
	      setSuppression('test_theme_preview');
	      return 'test_theme_preview';
	    }
	
	    if (explicitTest && isDisabledValue(explicitTest)) {
	      clearSuppression();
	      return '';
    }

    if (explicitTest && isEnabledValue(explicitTest)) {
      setSuppression('explicit_test_parameter');
      return 'explicit_test_parameter';
    }

    if (params && (params.has('preview_theme_id') || params.has('shgpvid'))) {
      setSuppression('theme_preview');
      return 'theme_preview';
    }

    if (window.Shopify && window.Shopify.designMode) {
      setSuppression('shopify_design_mode');
      return 'shopify_design_mode';
    }

    if (window.EVOLOVA_ANALYTICS_SUPPRESS) {
      return window.EVOLOVA_ANALYTICS_SUPPRESSION_REASON || 'global_suppression';
    }

    try {
      return window.sessionStorage.getItem(suppressStorageKey) || '';
    } catch (error) {
      return '';
	    }
	  }

	  function isTestThemePreview() {
	    var theme = window.Shopify && window.Shopify.theme;
	    if (!theme) return false;
	    var themeId = String(theme.id || theme.theme_store_id || '');
	    if (themeId === '188705407269') return true;
	    var themeName = String(theme.name || theme.role || '').toLowerCase();
	    return /测试主题|test|preview|draft|development/.test(themeName);
	  }

  function getCurrency() {
    return (
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.shopCurrency) ||
      'USD'
    );
  }

  function getDeviceCategory() {
    var width = window.innerWidth || document.documentElement.clientWidth || 0;
    if (width < 750) return 'mobile';
    if (width < 1025) return 'tablet';
    return 'desktop';
  }

  function getPageContext(extra) {
    return Object.assign(
      {
        event_source: 'evolova_theme',
        page_location: getSanitizedPageLocation(),
        page_path: window.location.pathname,
        device_category: getDeviceCategory()
      },
      extra || {}
    );
  }

  function isContentPathEvent(eventName) {
    return /^(content_impression|content_engaged|content_click|content_exit|page_exit|add_to_cart_click|add_to_cart_success|add_to_cart_error|add_to_cart)$/.test(String(eventName || ''));
  }

  function buildContentDebugMirrorPayload(eventName, payload, suppressionReason) {
    var allowedFields = [
      'event_schema',
      'page_type',
      'template_id',
      'content_id',
      'content_type',
      'content_position',
      'action_type',
	      'destination_type',
	      'exit_signal',
	      'visible_ratio',
	      'engaged_ms',
	      'last_content_id',
	      'last_engaged_content_id',
	      'product_handle',
	      'variant_id',
	      'quantity',
	      'value',
	      'currency',
	      'source_area',
	      'item_list_name',
	      'item_list_id',
	      'index',
	      'action_id',
	      'attempt_id',
	      'tracking_source',
	      'fallback_reason',
	      'error_reason'
	    ];
    var debugPayload = {
      event: eventName,
      analytics_suppressed: true,
      suppression_reason: suppressionReason || 'suppressed'
    };
    allowedFields.forEach(function (field) {
      var value = payload && payload[field];
      if (value === undefined || value === null || value === '') return;
      debugPayload[field] = value;
    });
    return debugPayload;
  }

  function writeContentDebugMirror(eventName, payload, suppressionReason) {
    if (!suppressionReason || !isContentPathEvent(eventName) || !document.documentElement) return;
    var debugPayload = buildContentDebugMirrorPayload(eventName, payload, suppressionReason);
    contentDebugMirrorRing.push(debugPayload);
    if (contentDebugMirrorRing.length > contentDebugMirrorLimit) {
      contentDebugMirrorRing = contentDebugMirrorRing.slice(contentDebugMirrorRing.length - contentDebugMirrorLimit);
    }

    document.documentElement.setAttribute('data-evo-analytics-debug-event', debugPayload.event || '');
    document.documentElement.setAttribute('data-evo-analytics-debug-schema', debugPayload.event_schema || '');
    document.documentElement.setAttribute('data-evo-analytics-debug-content-id', debugPayload.content_id || '');
    document.documentElement.setAttribute('data-evo-analytics-debug-suppressed', 'true');

    var script = document.getElementById(contentDebugMirrorScriptId);
    if (!script) {
      script = document.createElement('script');
      script.type = 'application/json';
      script.id = contentDebugMirrorScriptId;
      script.hidden = true;
      document.documentElement.appendChild(script);
    }
    script.textContent = JSON.stringify({
      latest: debugPayload,
      events: contentDebugMirrorRing
    });
  }

  function sendGtag(eventName, params) {
    var payload = getPageContext(params);
    var suppressionReason = getSuppressionReason();
    window[dataLayerName] = window[dataLayerName] || [];
    window[debugLayerName] = window[debugLayerName] || [];
    window[debugLayerName].push(Object.assign({
      event: eventName,
      timestamp: Date.now(),
      analytics_suppressed: Boolean(suppressionReason),
      suppression_reason: suppressionReason || undefined
    }, payload));

    if (suppressionReason) {
      writeContentDebugMirror(eventName, payload, suppressionReason);
      return;
    }

    if (typeof window.analyzelyGtag === 'function') {
      window.analyzelyGtag('event', eventName, payload);
    } else if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, payload);
    } else {
      window[dataLayerName].push(['event', eventName, payload]);
    }
  }

  function dedupe(key, ttl) {
    var now = Date.now();
    if (recentEvents[key] && now - recentEvents[key] < ttl) return true;
    recentEvents[key] = now;
    return false;
  }

  function centsToAmount(value) {
    var number = Number(value);
    if (!Number.isFinite(number)) return 0;
    return number > 1000 ? number / 100 : number;
  }

  function productHandleFromUrl(url) {
    var match = String(url || window.location.pathname).match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function getDataValue(node, key) {
    var attr = 'data-' + key.replace(/[A-Z]/g, function (letter) {
      return '-' + letter.toLowerCase();
    });
    var current = node instanceof Element ? node : null;

    while (current) {
      if (current.dataset && current.dataset[key]) return current.dataset[key];
      if (current.getAttribute && current.getAttribute(attr)) return current.getAttribute(attr);
      current = current.parentElement;
    }

    return '';
  }

  function findVariant(product, variantId) {
    if (!product || !Array.isArray(product.variants)) return null;
    return product.variants.find(function (variant) {
      return String(variant.id) === String(variantId);
    });
  }

  function getSourceArea(target, form) {
    var node = target || form;
    if (!node) return 'unknown';
    var explicitSourceArea = getDataValue(node, 'sourceArea');
    if (explicitSourceArea) return explicitSourceArea;
    if (node.closest?.('cart-drawer')) return 'cart_drawer';
    if (node.closest?.('.template-cart, .section--main-cart, cart-items-component')) return 'cart_page';
    if (node.closest?.('sticky-atc') || String(node.id || '').indexOf('StickyCart-ProductSubmitButton') === 0) return 'sticky_add_to_cart';
    if (node.closest?.('.main-product-information, product-info, .product-form__buttons')) return 'pdp_main';
    if (node.closest?.('quick-add-modal')) return 'quick_add';
    if (node.closest?.('.evo-collection-card__actions, .card--block-button, .card, .card-product, .product-card, .collection, .template-collection, .template-search')) return 'collection_card';
    return 'unknown';
  }

  function getListName(target, form) {
    var node = target || form;
    return getDataValue(node, 'itemListName') || getSourceArea(node, form);
  }

  function getListId(target, form) {
    var node = target || form;
    return getDataValue(node, 'itemListId') || getDataValue(node, 'sourceArea') || getSourceArea(node, form);
  }

  function getCardPosition(target, form) {
    var position = getDataValue(target || form, 'cardPosition');
    var number = Number(position);
    return Number.isFinite(number) && number > 0 ? number : undefined;
  }

  function getFormForTarget(target) {
    if (!target) return null;
    if (target.closest?.('form')) return target.closest('form');
    if (target.form instanceof HTMLFormElement) return target.form;
    var formId = target.getAttribute?.('form');
    return formId ? document.getElementById(formId) : null;
  }

  function getFormDataValue(form, name) {
    if (!form) return '';
    try {
      return new FormData(form).get(name) || '';
    } catch (e) {
      var input = form.querySelector('[name="' + name + '"]');
      return input ? input.value : '';
    }
  }

  function getQuantity(form, fallback) {
    var quantity = Number(getFormDataValue(form, 'quantity') || fallback || 1);
    return Math.max(1, Number.isFinite(quantity) ? quantity : 1);
  }

  function getProductMeta(form, variantId, lineItem, target) {
    var metaProduct = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
    var variant = findVariant(metaProduct, variantId || lineItem?.variant_id || lineItem?.id);
    var contextNode = target || form;
    var dataTitle = getDataValue(contextNode, 'productTitle');
    var dataHandle = getDataValue(contextNode, 'productHandle');
    var dataProductId = getDataValue(contextNode, 'productId');
    var dataVariantId = getDataValue(contextNode, 'variantId');
    var title =
      lineItem?.product_title ||
      dataTitle ||
      (contextNode && contextNode.closest?.('[data-product-title]') && contextNode.closest('[data-product-title]').dataset.productTitle) ||
      (metaProduct && metaProduct.title) ||
      document.querySelector('[data-product-title]')?.textContent ||
      document.querySelector('h1')?.textContent ||
      document.title;
    var productHandle = lineItem?.handle || dataHandle || productHandleFromUrl();
    var normalizedVariantId = String(variantId || dataVariantId || lineItem?.variant_id || lineItem?.id || (variant && variant.id) || '');

    return {
      item_id: normalizedVariantId,
      item_name: String(title || '').trim(),
      item_brand: String(lineItem?.vendor || (metaProduct && metaProduct.vendor) || 'Evolova'),
      item_variant: String(lineItem?.variant_title || (variant && (variant.public_title || variant.name || variant.title)) || ''),
      item_category: String(lineItem?.product_type || (metaProduct && metaProduct.type) || 'product'),
      price: centsToAmount(lineItem?.price || (variant && variant.price)),
      product_handle: productHandle,
      product_id: String(lineItem?.product_id || dataProductId || (metaProduct && metaProduct.id) || ''),
      variant_id: normalizedVariantId
    };
  }

  function buildItem(item, quantity, extra) {
    return Object.assign({
      item_id: item.item_id,
      item_name: item.item_name,
      item_brand: item.item_brand,
      item_variant: item.item_variant,
      item_category: item.item_category,
      price: item.price || undefined,
      quantity: quantity
    }, extra || {});
  }

  function buildProductPayload(item, quantity, extra) {
    var itemExtra = {};
    if (extra?.item_list_name) itemExtra.item_list_name = extra.item_list_name;
    if (extra?.item_list_id) itemExtra.item_list_id = extra.item_list_id;
    if (extra?.index) itemExtra.index = extra.index;
    var value = item.price ? item.price * quantity : undefined;
    return Object.assign(
      {
        currency: getCurrency(),
        value: value,
        product_handle: item.product_handle,
        product_id: item.product_id,
        variant_id: item.variant_id,
        items: [buildItem(item, quantity, itemExtra)]
      },
      extra || {}
    );
	  }

	  function buildAtcContextPayload(item, quantity, extra) {
	    var lastContent = contentEngagementState.currentContentMeta || {};
	    var lastEngagedContent = contentEngagementState.lastEngagedContentMeta || {};
	    return compactPayload(Object.assign({
	      event_schema: contentSchemaVersion,
	      page_type: getPageType(),
	      template_id: getTemplateId(),
	      last_content_id: lastContent.content_id,
	      last_engaged_content_id: lastEngagedContent.content_id,
	      product_handle: item && item.product_handle,
	      variant_id: item && item.variant_id,
	      quantity: quantity || undefined,
	      value: item && item.price ? item.price * (quantity || 1) : undefined,
	      currency: getCurrency()
	    }, extra || {}));
	  }

	  function enrichAtcPayload(payload, item, quantity, extra) {
	    return Object.assign(payload || {}, buildAtcContextPayload(item, quantity, extra));
	  }

	  function getAtcAttemptKey(attemptId) {
	    return attemptId ? 'attempt:' + attemptId : '';
	  }

	  function hasTerminalAtcAttempt(attemptId) {
	    var key = getAtcAttemptKey(attemptId);
	    return !!(key && terminalCartAttempts[key]);
	  }

	  function markTerminalAtcAttempt(attemptId, status) {
	    var key = getAtcAttemptKey(attemptId);
	    if (!key) return true;
	    if (terminalCartAttempts[key]) return false;
	    terminalCartAttempts[key] = status || 'terminal';
	    return true;
	  }

  function normalizeTrackedItems(items, extra) {
    if (!Array.isArray(items)) return [];
    return items
      .map(function (item, index) {
        var quantity = Math.max(1, Number(item.quantity || 1) || 1);
        return {
          item_id: String(item.item_id || item.variant_id || item.id || ''),
          item_name: String(item.item_name || item.product_title || item.title || 'Bundle item'),
          item_brand: String(item.item_brand || item.vendor || 'Evolova'),
	          item_variant: String(item.item_variant || item.variant_title || ''),
	          item_category: String(item.item_category || item.product_type || 'product'),
	          price: centsToAmount(item.price),
	          product_handle: String(item.product_handle || item.handle || ''),
	          product_id: String(item.product_id || ''),
	          quantity: quantity,
          item_list_name: item.item_list_name || extra?.item_list_name,
          item_list_id: item.item_list_id || extra?.item_list_id,
          index: item.index || index + 1
        };
      })
      .filter(function (item) {
        return item.item_id;
      });
  }

  function buildMultiItemPayload(items, extra) {
    var normalizedItems = normalizeTrackedItems(items, extra);
    var value = normalizedItems.reduce(function (sum, item) {
      return sum + (Number(item.price) || 0) * (Number(item.quantity) || 1);
    }, 0);

    return Object.assign(
      {
        currency: getCurrency(),
        value: value || undefined,
        items: normalizedItems,
        bundle_item_count: normalizedItems.length
      },
      extra || {}
    );
  }

	  function rememberExplicitCartAdd(variantId, sourceArea, actionId) {
	    var now = Date.now();
	    if (variantId) recentExplicitCartAdds['variant:' + variantId + ':' + sourceArea] = now;
	    if (actionId) recentExplicitCartAdds['action:' + actionId] = now;
	  }

	  function getAttemptId(detail) {
	    return detail?.attemptId || detail?.attempt_id || detail?.actionId || '';
	  }

	  function getFormAttemptId(form) {
	    return (form && form.dataset && form.dataset.evoCartAttemptId) || '';
	  }

	  function isManagedProductForm(form) {
	    return !!(form && form.closest && form.closest('product-form-component'));
	  }

  function hasRecentExplicitCartAdd(variantId, sourceArea, actionId) {
    var now = Date.now();
    var variantKey = variantId ? 'variant:' + variantId + ':' + sourceArea : '';
    var actionKey = actionId ? 'action:' + actionId : '';
    return (
      (variantKey && recentExplicitCartAdds[variantKey] && now - recentExplicitCartAdds[variantKey] < 6000) ||
      (actionKey && recentExplicitCartAdds[actionKey] && now - recentExplicitCartAdds[actionKey] < 6000)
	    );
	  }

	  function isExplicitAddToCartSource(source) {
	    var value = String(source || '').toLowerCase();
	    if (!value) return false;
	    if (/quick-order|quick_order|quick-add-bulk|quick_add_bulk|cart-drawer|cart_drawer|cart-items|cart_items|quantity|line-update|line_update|change/.test(value)) return false;
	    return /product-form|product_form|cart-add|cart_add|add-to-cart|add_to_cart|buy_now|sticky|bundle|quick-add|quick_add/.test(value);
	  }

	  function getLineQuantityByVariant(cart, variantId) {
	    if (!cart || !variantId || !Array.isArray(cart.items)) return 0;
	    return cart.items.reduce(function (sum, line) {
	      return sum + (String(line.variant_id || line.id || '') === String(variantId) ? Number(line.quantity || 0) : 0);
	    }, 0);
	  }

	  function getPubSubCartUpdateEvidence(event) {
	    var variantId = event?.productVariantId || event?.variantId || '';
	    if (variantId) return 'product_variant_id';
	    if (event?.cartData && lastCart && Array.isArray(event.cartData.items)) {
	      var addedLine = event.cartData.items.some(function (line) {
	        var lineVariantId = line.variant_id || line.id;
	        return getLineQuantityByVariant(event.cartData, lineVariantId) > getLineQuantityByVariant(lastCart, lineVariantId);
	      });
	      if (addedLine) return 'new_cart_line';
	    }
	    return '';
	  }

	  function shouldTrackPubSubCartUpdate(event) {
	    if (!event || !event.cartData) return false;
	    if (!isExplicitAddToCartSource(event.source)) return false;
	    var evidence = getPubSubCartUpdateEvidence(event);
	    if (!evidence) return false;
	    if (hasRecentExplicitCartAdd(event.productVariantId || event.variantId, event.sourceArea || 'product_form', event.actionId)) return false;
	    event.__evoFallbackReason = evidence;
	    return true;
	  }

	  function normalizeAddToCartErrorReason(reason, response) {
	    var text = String(reason || response?.message || response?.description || '').toLowerCase();
	    if (/disabled|aria_disabled|missing_submit_button/.test(text)) return 'disabled_submit';
	    if (/missing_variant|variant_id|no variant|select.*variant|variant.*required/.test(text)) return 'missing_variant';
	    if (/sold\s*out|out of stock|not enough|insufficient stock|inventory/.test(text)) return 'sold_out';
	    if (/unavailable|not available|cannot be added|can't be added/.test(text)) return 'unavailable';
	    if (/terms|validation|invalid|required|missing_cart_add_form|repeated_click/.test(text)) return 'validation_error';
	    if (/network|timeout|failed to fetch|load failed/.test(text)) return 'network_error';
	    if (/cart|shopify|api|bundle_cart_add|redirect_fast_path/.test(text)) return 'cart_api_error';
	    return 'unknown';
	  }

	  function sanitizeAddToCartErrorMessage(message) {
	    return truncateParam(
	      String(message || '')
	        .replace(/https?:\/\/\S+/gi, '')
	        .replace(/[?&][a-z0-9_-]+=[^&\s]+/gi, '')
	        .replace(/\b(token|cart_token|authorization|password|email|phone)=\S+/gi, ''),
	      99
	    );
	  }

  function buildCartPayload(cart, extra) {
    var items = Array.isArray(cart?.items)
      ? cart.items.map(function (line) {
              return buildItem(getProductMeta(null, line.variant_id || line.id, line), line.quantity || 1);
        })
      : [];

    return Object.assign(
      {
	        currency: getCurrency(),
	        value: centsToAmount(cart?.total_price),
	        cart_item_count: cart?.item_count || 0,
	        items: items
	      },
      extra || {}
    );
  }

  function fetchCart() {
    var rootUrl = window.routes?.root_url || '/';
    var cartUrl = rootUrl.replace(/\/?$/, '/') + 'cart.js';
    return fetch(cartUrl, { credentials: 'same-origin', cache: 'no-store' })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        if (cart) lastCart = cart;
        return cart;
      })
      .catch(function () {
        return null;
      });
  }

	  function trackAddToCartClick(form, target, source, detail) {
	    var sourceArea = detail?.sourceArea || getSourceArea(target, form);
	    var variantId = getFormDataValue(form, 'id');
	    var quantity = getQuantity(form);
	    var attemptId = getAttemptId(detail) || getFormAttemptId(form);
	    var trackedItems = normalizeTrackedItems(detail?.items, {
	      item_list_name: detail?.itemListName || getListName(target, form),
	      item_list_id: detail?.itemListId || getListId(target, form)
    });
    var item = getProductMeta(form, detail?.variantId || variantId || trackedItems[0]?.item_id, null, target);
	    var shouldCheckDisabled = source === 'pointerdown' || source === 'submit';
	    var disabled = shouldCheckDisabled && (target?.matches?.('[disabled], [aria-disabled="true"]') || target?.closest?.('[disabled], [aria-disabled="true"]'));
		    var listName = detail?.itemListName || getListName(target, form);
		    var listId = detail?.itemListId || getListId(target, form);
		    var position = getCardPosition(target, form);
		    if (attemptId && dedupe('atc-click-attempt:' + attemptId, 8000)) return;
		    setAtcJourneyState('clicked', sourceArea, attemptId);

		    if (trackedItems.length) {
      var bundleClickKey = 'atc-click:items:' + trackedItems.map(function (trackedItem) {
        return trackedItem.item_id + 'x' + trackedItem.quantity;
      }).join('|') + ':' + sourceArea;
      if (dedupe(bundleClickKey, 1500)) return;
	      var bundleItem = {
	        product_handle: trackedItems[0]?.product_handle || productHandleFromUrl(),
	        variant_id: trackedItems[0]?.item_id,
	        price: trackedItems[0]?.price
	      };
	      sendGtag(
	        'add_to_cart_click',
	        enrichAtcPayload(buildMultiItemPayload(trackedItems, {
		          source_area: sourceArea,
		          item_list_name: listName,
		          item_list_id: listId,
		          index: position,
		          submit_source: source || 'unknown',
		          action_id: attemptId || undefined,
		          attempt_id: attemptId || undefined,
		          bundle_tracking: true
		        }), bundleItem, quantity, {
		          source_area: sourceArea,
		          item_list_name: listName,
		          item_list_id: listId,
		          index: position,
		          action_id: attemptId || undefined,
		          attempt_id: attemptId || undefined
		        })
		      );
      return;
    }

	    if (!form || !/\/cart\/add/.test(form.action || '')) {
	      setAtcJourneyState('error', sourceArea, attemptId);
		      sendGtag('add_to_cart_error', buildAtcContextPayload(item, quantity, {
	          error_reason: normalizeAddToCartErrorReason('missing_cart_add_form'),
		          source_area: sourceArea,
		          item_list_name: listName,
		          item_list_id: listId,
		          index: position,
		          submit_source: source || 'unknown',
		          action_id: attemptId || undefined,
		          attempt_id: attemptId || undefined
		        }));
	      return;
	    }

	    if (disabled) {
	      setAtcJourneyState('error', sourceArea, attemptId);
	      var disabledKey = 'atc-disabled:' + variantId + ':' + sourceArea;
      if (dedupe(disabledKey, 1500)) return;
      sendGtag(
        'add_to_cart_error',
	        enrichAtcPayload(buildProductPayload(item, quantity, {
	          error_reason: normalizeAddToCartErrorReason('disabled_button'),
		          source_area: sourceArea,
		          item_list_name: listName,
		          item_list_id: listId,
		          index: position,
		          submit_source: source || 'unknown',
		          action_id: attemptId || undefined,
		          attempt_id: attemptId || undefined
		        }), item, quantity, {
		          source_area: sourceArea,
		          item_list_name: listName,
		          item_list_id: listId,
		          index: position,
		          action_id: attemptId || undefined,
		          attempt_id: attemptId || undefined
		        })
		      );
      return;
    }

	    if (!variantId) {
	      setAtcJourneyState('error', sourceArea, attemptId);
	      sendGtag(
        'add_to_cart_error',
	        enrichAtcPayload(buildProductPayload(item, quantity, {
	          error_reason: normalizeAddToCartErrorReason('missing_variant_id'),
		          source_area: sourceArea,
		          item_list_name: listName,
		          item_list_id: listId,
		          index: position,
		          submit_source: source || 'unknown',
		          action_id: attemptId || undefined,
		          attempt_id: attemptId || undefined
		        }), item, quantity, {
		          source_area: sourceArea,
		          item_list_name: listName,
		          item_list_id: listId,
		          index: position,
		          action_id: attemptId || undefined,
		          attempt_id: attemptId || undefined
		        })
		      );
      return;
    }

    var key = 'atc-click:' + variantId + ':' + quantity + ':' + sourceArea;
    if (dedupe(key, 1500)) return;

    sendGtag(
      'add_to_cart_click',
	      enrichAtcPayload(buildProductPayload(item, quantity, {
		        source_area: sourceArea,
		        item_list_name: listName,
		        item_list_id: listId,
		        index: position,
		        submit_source: source || 'unknown',
		        action_id: attemptId || undefined,
		        attempt_id: attemptId || undefined
		      }), item, quantity, {
		        source_area: sourceArea,
		        item_list_name: listName,
		        item_list_id: listId,
		        index: position,
		        action_id: attemptId || undefined,
		        attempt_id: attemptId || undefined
		      })
		    );
	  }

  function trackAddToCartSuccess(detail) {
    var form = detail?.form || null;
    var response = detail?.response || null;
    var variantId = detail?.variantId || response?.variant_id || response?.id || getFormDataValue(form, 'id');
    var quantity = Number(detail?.quantity || response?.quantity || getQuantity(form));
    var trackedItems = normalizeTrackedItems(detail?.items, {
      item_list_name: detail?.itemListName || getListName(detail?.target || null, form),
      item_list_id: detail?.itemListId || getListId(detail?.target || null, form)
    });
    var item = getProductMeta(form, variantId, response, detail?.target || null);
	    var sourceArea = detail?.sourceArea || getSourceArea(null, form);
	    var listName = detail?.itemListName || getListName(detail?.target || null, form);
	    var listId = detail?.itemListId || getListId(detail?.target || null, form);
	    var position = detail?.index || detail?.cardPosition || getCardPosition(detail?.target || null, form);
	    var attemptId = getAttemptId(detail);
	    if (hasTerminalAtcAttempt(attemptId)) return;
	    setAtcJourneyState('success', sourceArea, attemptId);

	    if (trackedItems.length) {
      var multiKey = 'atc-success:items:' + trackedItems.map(function (trackedItem) {
        return trackedItem.item_id + 'x' + trackedItem.quantity;
	      }).join('|') + ':' + sourceArea;
	      if (dedupe(multiKey, 4000)) return;
	      if (!markTerminalAtcAttempt(attemptId, 'success')) return;
	      var bundleItem = {
	        product_handle: trackedItems[0]?.product_handle || productHandleFromUrl(),
	        variant_id: trackedItems[0]?.item_id,
	        price: trackedItems[0]?.price
	      };
		      var multiPayload = buildMultiItemPayload(trackedItems, {
		        source_area: sourceArea,
		        item_list_name: listName,
		        item_list_id: listId,
		        cart_action_source: detail?.source || 'cart_add',
		        action_id: detail?.actionId || attemptId || undefined,
		        attempt_id: attemptId || undefined,
		        bundle_tracking: true,
		        tracking_source: detail?.trackingSource || 'explicit_event',
		        fallback_reason: detail?.fallbackReason || undefined,
		        transport_type: 'beacon'
		      });
	      multiPayload = enrichAtcPayload(multiPayload, bundleItem, quantity, {
	        source_area: sourceArea,
	        item_list_name: listName,
	        item_list_id: listId,
	        action_id: detail?.actionId || attemptId || undefined,
	        attempt_id: attemptId || undefined,
	        tracking_source: detail?.trackingSource || 'explicit_event',
	        fallback_reason: detail?.fallbackReason || undefined,
	        transport_type: 'beacon'
	      });
	      sendGtag('add_to_cart_success', multiPayload);
	      sendGtag('add_to_cart', multiPayload);
      rememberExplicitCartAdd(variantId || trackedItems[0]?.item_id, sourceArea, detail?.actionId);
      fetchCart();
      return;
    }

	    var key = 'atc-success:' + variantId + ':' + quantity + ':' + sourceArea;
	    if (dedupe(key, 4000)) return;
	    if (!markTerminalAtcAttempt(attemptId, 'success')) return;

		    var payload = buildProductPayload(item, quantity, {
		      source_area: sourceArea,
		      item_list_name: listName,
		      item_list_id: listId,
		      index: position,
		      cart_line_key: response?.key,
		      cart_action_source: detail?.source || 'cart_add',
		      action_id: detail?.actionId || attemptId || undefined,
		      attempt_id: attemptId || undefined,
		      tracking_source: detail?.trackingSource || 'explicit_event',
		      fallback_reason: detail?.fallbackReason || undefined,
		      transport_type: 'beacon'
		    });
	    payload = enrichAtcPayload(payload, item, quantity, {
	      source_area: sourceArea,
	      item_list_name: listName,
	      item_list_id: listId,
	      index: position,
	      action_id: detail?.actionId || attemptId || undefined,
	      attempt_id: attemptId || undefined,
	      tracking_source: detail?.trackingSource || 'explicit_event',
	      fallback_reason: detail?.fallbackReason || undefined,
	      transport_type: 'beacon'
	    });

    sendGtag('add_to_cart_success', payload);
    sendGtag('add_to_cart', payload);
    rememberExplicitCartAdd(variantId, sourceArea, detail?.actionId);
    fetchCart();
  }

  function trackAddToCartError(detail) {
    var form = detail?.form || null;
    var response = detail?.response || null;
    var variantId = detail?.variantId || response?.variant_id || response?.id || getFormDataValue(form, 'id');
    var quantity = Number(detail?.quantity || getQuantity(form));
    var item = getProductMeta(form, variantId, response, detail?.target || null);
    var sourceArea = detail?.sourceArea || getSourceArea(null, form);
	    var listName = detail?.itemListName || getListName(detail?.target || null, form);
	    var listId = detail?.itemListId || getListId(detail?.target || null, form);
	    var position = detail?.index || detail?.cardPosition || getCardPosition(detail?.target || null, form);
		    var rawReason = detail?.reason || response?.message || response?.description || 'cart_add_error';
		    var reason = normalizeAddToCartErrorReason(rawReason, response);
		    var errorMessage = sanitizeAddToCartErrorMessage(detail?.message || response?.description || response?.message || '');
		    var key = 'atc-error:' + variantId + ':' + reason + ':' + sourceArea;
	    var attemptId = getAttemptId(detail);
	    if (!detail?.repeatedClick && hasTerminalAtcAttempt(attemptId)) return;
	    setAtcJourneyState('error', sourceArea, attemptId);
	    if (dedupe(key, 1500)) return;
	    if (!detail?.repeatedClick && !markTerminalAtcAttempt(attemptId, 'error')) return;

	    sendGtag(
	      'add_to_cart_error',
	      enrichAtcPayload(buildProductPayload(item, quantity, {
	        source_area: sourceArea,
	        item_list_name: listName,
		        item_list_id: listId,
		        index: position,
		        error_reason: reason,
		        error_message: errorMessage || undefined,
		        action_id: detail?.actionId || attemptId || undefined,
		        attempt_id: attemptId || undefined,
		        repeated_click: detail?.repeatedClick || undefined
		      }), item, quantity, {
		        source_area: sourceArea,
		        item_list_name: listName,
		        item_list_id: listId,
		        index: position,
		        action_id: detail?.actionId || attemptId || undefined,
		        attempt_id: attemptId || undefined,
		        tracking_source: detail?.trackingSource || 'explicit_event',
		        fallback_reason: detail?.fallbackReason || undefined
		      })
	    );
	  }

  function trackCartDrawerOpen(detail) {
    fetchCart().then(function (cart) {
      if (!cart || !cart.item_count) return;
      var key = 'cart-drawer-open:' + (cart.token || cart.item_count + ':' + cart.total_price);
      if (dedupe(key, 5000)) return;
      var payload = buildCartPayload(cart, {
        source_area: getSourceArea(detail?.triggeredBy || null, null)
      });
      sendGtag('cart_drawer_open', payload);
      sendGtag('view_cart', payload);
    });
  }

  function trackCheckoutHandoff(detail) {
    var sourceArea = detail?.sourceArea || getSourceArea(detail?.target || null, null);
    var response = detail?.response || null;

    if (response && (response.variant_id || response.id)) {
      var variantId = detail?.variantId || response.variant_id || response.id;
      var quantity = Number(detail?.quantity || response.quantity || 1);
      var item = getProductMeta(detail?.form || null, variantId, response);
      var productPayload = buildProductPayload(item, quantity, {
        source_area: sourceArea,
        handoff_source: detail?.source || 'buy_now'
      });
      var productKey = 'checkout-handoff-product:' + variantId + ':' + sourceArea;
      if (!dedupe(productKey, 5000)) {
        sendGtag('checkout_handoff', productPayload);
        sendGtag('begin_checkout', productPayload);
      }
      return;
    }

    var cart = lastCart;
    if (!cart || !cart.item_count) {
      fetchCart().then(function (freshCart) {
        if (freshCart && freshCart.item_count) trackCheckoutHandoff(Object.assign({}, detail, { cart: freshCart }));
      });
      return;
    }

    var key = 'checkout-handoff-cart:' + (cart.token || cart.item_count + ':' + cart.total_price) + ':' + sourceArea;
    if (dedupe(key, 5000)) return;
    var payload = buildCartPayload(cart, {
      source_area: sourceArea,
      handoff_source: detail?.source || 'cart_checkout'
    });
    sendGtag('checkout_handoff', payload);
    sendGtag('begin_checkout', payload);
  }

	  function trackVariantSelectFromPending(variant) {
	    if (!pendingVariantSelection) return;
	    var pending = pendingVariantSelection;
    pendingVariantSelection = null;
    var variantId = variant?.id || '';
    var key = 'variant-select:' + pending.optionName + ':' + pending.optionValue + ':' + variantId;
    if (dedupe(key, 1000)) return;

    sendGtag('variant_select', {
      product_handle: productHandleFromUrl(),
      variant_id: String(variantId),
      option_name: pending.optionName,
      option_value: pending.optionValue,
      selected_options: Array.isArray(variant?.options) ? variant.options.join(' / ') : undefined,
      variant_available: variant?.available,
      price: centsToAmount(variant?.price),
      source_area: pending.sourceArea
	    });
	  }

	  var contentEngagementState = {
	    initialized: false,
	    startedAt: Date.now(),
	    activeStartedAt: Date.now(),
	    activeTimeMs: 0,
	    isActive: true,
	    maxScrollDepth: 0,
	    depthCheckpoints: {},
	    viewedById: {},
	    impressedById: {},
	    engagedById: {},
	    exitedById: {},
	    viewedList: [],
	    candidates: [],
	    currentContentMeta: null,
	    previousContentMeta: null,
	    lastEngagedContentMeta: null,
	    currentContentStartedAt: 0,
	    exitSent: false,
	    visibilitySnapshotAt: 0,
	    scrollTicking: false,
	    refreshTicking: false,
	    observer: null,
	    mutationObserver: null,
	    impressionTimers: {},
	    engagementTimers: {},
	    maxSectionViews: 24,
	    lastInteractionType: 'none',
	    lastInteractionContentId: '',
	    lastInteractionAt: 0,
	    navigationIntent: 'none',
	    exitTargetType: 'none',
	    exitTargetDomain: '',
	    exitTargetPath: '',
	    lastAtcStatus: 'none',
	    lastAtcSourceArea: '',
	    lastAtcActionId: ''
	  };

	  function setAtcJourneyState(status, sourceArea, actionId) {
	    contentEngagementState.lastAtcStatus = status || 'none';
	    contentEngagementState.lastAtcSourceArea = sourceArea || 'unknown';
	    contentEngagementState.lastAtcActionId = actionId || '';
	  }

	  function truncateParam(value, limit) {
	    var text = String(value || '').replace(/\s+/g, ' ').trim();
	    if (!text) return '';
	    return text.length > limit ? text.slice(0, limit - 1).trim() + '…' : text;
	  }

	  function slugifyParam(value, fallback) {
	    var slug = String(value || '')
	      .toLowerCase()
	      .replace(/[^a-z0-9]+/g, '_')
	      .replace(/^_+|_+$/g, '')
	      .slice(0, 64);
	    return slug || fallback || 'section';
	  }

	  function getLanguageCode() {
	    return (
	      (window.Shopify && window.Shopify.locale) ||
	      document.documentElement.getAttribute('lang') ||
	      (window.location.pathname.match(/^\/([a-z]{2})(?:\/|$)/) || [])[1] ||
	      'en'
	    );
	  }

	  function getPageTemplate() {
	    var bodyClass = document.body ? document.body.className || '' : '';
	    var templateClass = String(bodyClass).split(/\s+/).find(function (className) {
	      return className.indexOf('template-') === 0;
	    });
	    if (templateClass) return templateClass.replace(/^template-/, '') || 'page';
	    if (/\/products\//.test(window.location.pathname)) return 'product';
	    if (/\/collections\//.test(window.location.pathname)) return 'collection';
	    if (/\/cart/.test(window.location.pathname)) return 'cart';
	    if (/\/pages\//.test(window.location.pathname)) return 'page';
	    if (window.location.pathname === '/' || /^\/[a-z]{2}\/?$/.test(window.location.pathname)) return 'index';
	    return 'page';
	  }

	  function getPageType() {
	    var template = getPageTemplate();
	    if (template === 'index') return 'home';
	    if (/^product/.test(template) || /\/products\//.test(window.location.pathname)) return 'product';
	    if (/^collection/.test(template) || /\/collections\//.test(window.location.pathname)) return 'collection';
	    if (/^cart/.test(template) || /\/cart/.test(window.location.pathname)) return 'cart';
	    if (/^article|blog/.test(template) || /\/blogs\//.test(window.location.pathname)) return 'blog';
	    return template || 'page';
	  }

	  function getTemplateId() {
	    return slugifyParam(getPageTemplate(), 'page');
	  }

	  function collectionHandleFromUrl(url) {
	    var match = String(url || window.location.pathname).match(/\/collections\/([^/?#]+)/);
	    var handle = match ? match[1] : '';
	    return handle && handle !== 'all' ? slugifyParam(handle, 'collection') : '';
	  }

	  function getContentType(element) {
	    if (!element) return getPageTemplate();
	    var explicitType = element.getAttribute('data-evo-content-type');
	    if (explicitType) return slugifyParam(explicitType, 'content');
	    var pageTemplate = getPageTemplate();
	    var path = window.location.pathname;
	    var className = element.className ? String(element.className) : '';
	    if (pageTemplate === 'product' || /\/products\//.test(path)) return 'pdp';
	    if (pageTemplate === 'collection' || /\/collections\//.test(path)) return 'collection';
	    if (pageTemplate === 'cart' || /\/cart/.test(path)) return 'cart';
	    if (pageTemplate === 'index') {
	      if (/products|product-grid|pick|card-grid/.test(className)) return 'home_product_grid';
	      if (/hero/.test(className)) return 'hero';
	      if (/review/.test(className)) return 'reviews';
	      if (/compare|comparison/.test(className)) return 'comparison';
	      if (/tech|science|feature/.test(className)) return 'education';
	      return 'home';
	    }
	    if (/hero/.test(className)) return 'hero';
	    if (/review/.test(className)) return 'reviews';
	    if (/compare|comparison/.test(className)) return 'comparison';
	    if (/tech|science|feature/.test(className)) return 'education';
	    if (/article|page|guide|faq/.test(className) || /\/pages\//.test(path)) return 'page';
	    return pageTemplate;
	  }

	  function getScrollDepth() {
	    var doc = document.documentElement;
	    var body = document.body;
	    var scrollHeight = Math.max(
	      doc ? doc.scrollHeight : 0,
	      body ? body.scrollHeight : 0,
	      doc ? doc.offsetHeight : 0,
	      body ? body.offsetHeight : 0
	    );
	    var viewportHeight = window.innerHeight || (doc && doc.clientHeight) || 0;
	    if (!scrollHeight || scrollHeight <= viewportHeight) return 100;
	    var viewedBottom = (window.pageYOffset || doc.scrollTop || body.scrollTop || 0) + viewportHeight;
	    return Math.max(0, Math.min(100, Math.round((viewedBottom / scrollHeight) * 100)));
	  }

	  function getStableClassName(element) {
	    if (!element || !element.classList) return '';
	    var classes = Array.prototype.slice.call(element.classList);
	    return (
	      classes.find(function (className) {
	        return /^(evolova|evo)-[a-z0-9-]+$/.test(className);
	      }) ||
	      classes.find(function (className) {
	        return /^(shopify-section|section|template)-/.test(className);
	      }) ||
	      ''
	    );
	  }

	  function getContentName(element) {
	    if (!element) return '';
	    var explicitName =
	      element.getAttribute('data-evo-content-name') ||
	      element.getAttribute('data-content-name') ||
	      element.getAttribute('aria-label') ||
	      '';
	    if (explicitName) return truncateParam(explicitName, 80);
	    var heading = element.querySelector('h1, h2, h3, [data-evo-heading], .title, .heading');
	    return truncateParam(heading ? heading.textContent : getStableClassName(element), 80);
	  }

	  function autoAnnotateContentSections() {
	    var mappings = [
	      ['.evo-hero', 'home_hero', 'Homepage Hero', 'hero'],
	      ['.evo-products', 'home_product_picks', 'Homepage Product Picks', 'home_product_grid'],
	      ['.evo-tech', 'home_electric_tech', 'Evolova Electric 2.0', 'education'],
	      ['.evo-compare', 'home_comparison', 'Comparison', 'comparison'],
	      ['.evo-pornstar', 'home_pornstar', 'Evolova Pornstar', 'social_proof'],
	      ['.evo-reviews', 'home_reviews', 'Buyer Proof', 'reviews'],
	      ['.evo-cta', 'home_guides', 'Relevant Guides', 'education'],
	      ['.evo-newsletter', 'home_newsletter', 'Newsletter', 'newsletter'],
	      ['.evo-sex-doll-categories', 'home_body_type_categories', 'Body Type Categories', 'collection_links'],
	      ['.section-evolova-trust-bar, .evo-hero__bar', 'home_trust_bar', 'Trust Bar', 'trust'],
	      ['.collection-header, .collection-hero, [id*="collection-header"]', 'collection_header', 'Collection Header', 'collection_header'],
	      ['.facets-block-wrapper, facet-filters-form, .facets', 'collection_filters', 'Collection Filters', 'collection_filters'],
	      ['.pagination-wrapper, nav.pagination, .pagination', 'collection_pagination', 'Collection Pagination', 'collection_pagination'],
	      ['.product-information__media', 'pdp_media_gallery', 'Product Media Gallery', 'pdp_gallery'],
	      ['product-recommendations, .product-recommendations', 'pdp_recommendations', 'Product Recommendations', 'pdp_recommendations'],
	      ['.jdgm-widget, .jdgm-rev-widg', 'pdp_reviews', 'Reviews', 'pdp_reviews']
	    ];
	    mappings.forEach(function (entry, index) {
	      document.querySelectorAll(entry[0]).forEach(function (element) {
	        if (!element.hasAttribute('data-evo-content-track')) element.setAttribute('data-evo-content-track', '');
	        if (!element.getAttribute('data-evo-content-id')) element.setAttribute('data-evo-content-id', entry[1]);
	        if (!element.getAttribute('data-evo-content-name')) element.setAttribute('data-evo-content-name', entry[2]);
	        if (!element.getAttribute('data-evo-content-type')) element.setAttribute('data-evo-content-type', entry[3]);
	        if (!element.getAttribute('data-evo-content-position')) element.setAttribute('data-evo-content-position', String(index + 1));
	      });
	    });
	  }

	  function isTrackableContentElement(element) {
	    if (!element || !(element instanceof Element)) return false;
	    if (element.closest('header, footer, .header, .footer, .shopify-section-header, .shopify-section-footer')) return false;
	    if (element.hasAttribute('hidden') || element.getAttribute('aria-hidden') === 'true') return false;
	    var rect = element.getBoundingClientRect();
	    if (rect.width < 120 || rect.height < 80) return false;
	    var style = window.getComputedStyle ? window.getComputedStyle(element) : null;
	    if (style && (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0)) return false;
	    return true;
	  }

	  function getElementOverlapRatio(outer, inner) {
	    if (!outer || !inner) return 0;
	    var outerRect = outer.getBoundingClientRect();
	    var innerRect = inner.getBoundingClientRect();
	    var overlapWidth = Math.max(0, Math.min(outerRect.right, innerRect.right) - Math.max(outerRect.left, innerRect.left));
	    var overlapHeight = Math.max(0, Math.min(outerRect.bottom, innerRect.bottom) - Math.max(outerRect.top, innerRect.top));
	    var innerArea = Math.max(1, innerRect.width * innerRect.height);
	    return (overlapWidth * overlapHeight) / innerArea;
	  }

	  function hasSimilarTrackedAncestor(candidate, trackedElements) {
	    var candidateName = getContentName(candidate);
	    return trackedElements.some(function (tracked) {
	      if (!tracked || !tracked.contains(candidate) || tracked === candidate) return false;
	      var trackedName = getContentName(tracked);
	      var sameName = candidateName && trackedName && candidateName.toLowerCase() === trackedName.toLowerCase();
	      var trackedRect = tracked.getBoundingClientRect();
	      var candidateRect = candidate.getBoundingClientRect();
	      var similarHeight = trackedRect.height > 0 && candidateRect.height / trackedRect.height > 0.7;
	      var highOverlap = getElementOverlapRatio(tracked, candidate) > 0.8 && similarHeight;
	      return sameName || highOverlap;
	    });
	  }

	  function getContentCandidates() {
	    var main = document.querySelector('main') || document.body;
	    if (!main) return [];
	    autoAnnotateContentSections();
	    var explicitNodes = Array.prototype.slice.call(main.querySelectorAll('[data-evo-content-track]'));
	    if ((getPageTemplate() === 'product' || /\/products\//.test(window.location.pathname)) && explicitNodes.length) {
	      return explicitNodes.filter(isTrackableContentElement).slice(0, contentEngagementState.maxSectionViews);
	    }
	    var selector = [
	      '[data-evo-content-track]',
	      'section',
	      '.shopify-section',
	      '[id^="shopify-section-"]',
	      '.evolova-section',
	      '.evo-hero',
	      '.evo-products',
	      '.evo-tech',
	      '.evo-compare',
	      '.evo-pornstar',
	      '.evo-cta',
	      '.evo-product',
	      '.collection',
	      '.main-page'
	    ].join(',');
	    var nodes = Array.prototype.slice.call(main.querySelectorAll(selector));
	    var unique = [];
	    nodes.forEach(function (node) {
	      if (!isTrackableContentElement(node)) return;
	      if (unique.some(function (existing) { return existing === node; })) return;
	      if (hasSimilarTrackedAncestor(node, unique)) return;
	      unique.push(node);
	    });
	    return unique.slice(0, 32);
	  }

	  function buildContentMeta(element, index) {
	    var stableClass = getStableClassName(element);
	    var stableExplicitId = element.getAttribute('data-evo-content-id') || '';
	    var explicitId =
	      stableExplicitId ||
	      element.getAttribute('data-section-id') ||
	      element.getAttribute('data-section-type') ||
	      stableClass ||
	      element.id ||
	      '';
	    var pageTemplate = getPageTemplate();
	    var contentId = pageTemplate + ':' + slugifyParam(explicitId, 'section');
	    if (!stableExplicitId) contentId += ':' + (index + 1);
	    return {
	      content_id: contentId,
	      content_name: getContentName(element) || contentId,
	      content_type: getContentType(element),
	      content_index: index + 1,
	      content_position: Number(element.getAttribute('data-evo-content-position') || index + 1),
	      page_type: getPageType(),
	      template_id: getTemplateId(),
	      product_handle: productHandleFromUrl(),
	      collection_handle: collectionHandleFromUrl(),
	      language: getLanguageCode()
	    };
	  }

	  function compactPayload(payload) {
	    var cleaned = {};
	    Object.keys(payload || {}).forEach(function (key) {
	      var value = payload[key];
	      if (value === undefined || value === null || value === '') return;
	      cleaned[key] = value;
	    });
	    return cleaned;
	  }

	  function buildContentEventPayload(meta, extra) {
	    return compactPayload(Object.assign({
	      event_schema: contentSchemaVersion,
	      page_type: getPageType(),
	      template_id: getTemplateId(),
	      content_id: meta && meta.content_id,
	      content_type: meta && meta.content_type,
	      content_position: meta && meta.content_position,
	      product_handle: (meta && meta.product_handle) || productHandleFromUrl(),
	      collection_handle: (meta && meta.collection_handle) || collectionHandleFromUrl()
	    }, extra || {}));
	  }

	  function sendContentPathEvent(eventName, meta, extra) {
	    sendGtag(eventName, buildContentEventPayload(meta, extra));
	  }

	  function trackContentImpression(element, ratio) {
	    if (!element || contentEngagementState.viewedList.length >= contentEngagementState.maxSectionViews) return;
	    var meta = element.__evoContentMeta;
	    if (!meta || contentEngagementState.impressedById[meta.content_id]) return;
	    contentEngagementState.impressedById[meta.content_id] = true;
	    contentEngagementState.viewedById[meta.content_id] = true;
	    contentEngagementState.viewedList.push(meta);
	    contentEngagementState.maxScrollDepth = Math.max(contentEngagementState.maxScrollDepth, getScrollDepth());
	    sendContentPathEvent('content_impression', meta, {
	      visible_ratio: Number(Math.max(0.25, ratio || 0.25).toFixed(2))
	    });
	  }

	  function trackContentEngaged(element, ratio) {
	    var meta = element && element.__evoContentMeta;
	    if (!meta || contentEngagementState.engagedById[meta.content_id]) return;
	    contentEngagementState.engagedById[meta.content_id] = true;
	    contentEngagementState.lastEngagedContentMeta = meta;
	    sendContentPathEvent('content_engaged', meta, {
	      visible_ratio: Number(Math.max(0.5, ratio || 0.5).toFixed(2)),
	      engaged_ms: 2000
	    });
	  }

	  function trackContentExit(meta, signal) {
	    if (!meta || !meta.content_id || contentEngagementState.exitedById[meta.content_id]) return;
	    contentEngagementState.exitedById[meta.content_id] = true;
	    sendContentPathEvent('content_exit', meta, {
	      exit_signal: signal || 'content_change',
	      max_scroll_depth: contentEngagementState.maxScrollDepth,
	      page_duration_ms: Math.max(0, Date.now() - contentEngagementState.startedAt)
	    });
	  }

	  function clearContentTimer(bucket, contentId) {
	    if (!bucket || !bucket[contentId]) return;
	    window.clearTimeout(bucket[contentId]);
	    delete bucket[contentId];
	  }

	  function clearContentTimers() {
	    Object.keys(contentEngagementState.impressionTimers).forEach(function (key) {
	      clearContentTimer(contentEngagementState.impressionTimers, key);
	    });
	    Object.keys(contentEngagementState.engagementTimers).forEach(function (key) {
	      clearContentTimer(contentEngagementState.engagementTimers, key);
	    });
	  }

	  function scheduleContentThreshold(element, ratio) {
	    var meta = element && element.__evoContentMeta;
	    if (!meta) return;
	    if (document.visibilityState === 'hidden') {
	      clearContentTimer(contentEngagementState.impressionTimers, meta.content_id);
	      clearContentTimer(contentEngagementState.engagementTimers, meta.content_id);
	      return;
	    }
	    if (ratio >= 0.25 && !contentEngagementState.impressedById[meta.content_id]) {
	      if (!contentEngagementState.impressionTimers[meta.content_id]) {
	        contentEngagementState.impressionTimers[meta.content_id] = window.setTimeout(function () {
	          delete contentEngagementState.impressionTimers[meta.content_id];
	          trackContentImpression(element, ratio);
	        }, 250);
	      }
	    } else {
	      clearContentTimer(contentEngagementState.impressionTimers, meta.content_id);
	    }
	    if (ratio >= 0.5 && !contentEngagementState.engagedById[meta.content_id]) {
	      if (!contentEngagementState.engagementTimers[meta.content_id]) {
	        contentEngagementState.engagementTimers[meta.content_id] = window.setTimeout(function () {
	          delete contentEngagementState.engagementTimers[meta.content_id];
	          trackContentEngaged(element, ratio);
	        }, 2000);
	      }
	    } else {
	      clearContentTimer(contentEngagementState.engagementTimers, meta.content_id);
	    }
	  }

	  function setCurrentContent(element) {
	    var meta = element && element.__evoContentMeta;
	    if (!meta || contentEngagementState.currentContentMeta?.content_id === meta.content_id) return;
	    trackContentExit(contentEngagementState.currentContentMeta, 'content_change');
	    contentEngagementState.previousContentMeta = contentEngagementState.currentContentMeta;
	    contentEngagementState.currentContentMeta = meta;
	    contentEngagementState.currentContentStartedAt = Date.now();
	  }

	  function updateScrollDepthCheckpoints() {
	    contentEngagementState.maxScrollDepth = Math.max(contentEngagementState.maxScrollDepth, getScrollDepth());
	    [25, 50, 75, 90].forEach(function (checkpoint) {
	      if (contentEngagementState.depthCheckpoints[checkpoint]) return;
	      if (contentEngagementState.maxScrollDepth < checkpoint) return;
	      contentEngagementState.depthCheckpoints[checkpoint] = true;
	      sendGtag('content_depth_checkpoint', {
	        event_schema: contentSchemaVersion,
	        page_type: getPageType(),
	        template_id: getTemplateId(),
	        depth_checkpoint: checkpoint,
	        max_scroll_depth: contentEngagementState.maxScrollDepth,
	        product_handle: productHandleFromUrl(),
	        collection_handle: collectionHandleFromUrl(),
	        language: getLanguageCode()
	      });
	    });
	  }

	  function scheduleScrollDepthCheck() {
	    if (contentEngagementState.scrollTicking) return;
	    contentEngagementState.scrollTicking = true;
	    window.requestAnimationFrame(function () {
	      contentEngagementState.scrollTicking = false;
	      updateScrollDepthCheckpoints();
	      scanVisibleContentFallback(contentEngagementState.candidates);
	    });
	  }

	  function getRecentContentSummary(key) {
	    return contentEngagementState.viewedList
	      .slice(-3)
	      .map(function (item) {
	        return truncateParam(item[key], key === 'content_id' ? 64 : 48);
	      })
	      .filter(Boolean)
	      .join('|');
	  }

	  function pauseContentActiveTime() {
	    if (!contentEngagementState.isActive) return;
	    contentEngagementState.activeTimeMs += Math.max(0, Date.now() - contentEngagementState.activeStartedAt);
	    contentEngagementState.isActive = false;
	    clearContentTimers();
	  }

	  function resumeContentActiveTime() {
	    if (contentEngagementState.isActive) return;
	    contentEngagementState.isActive = true;
	    contentEngagementState.activeStartedAt = Date.now();
	  }

	  function getContentActiveTimeMs() {
	    var currentSlice = contentEngagementState.isActive
	      ? Math.max(0, Date.now() - contentEngagementState.activeStartedAt)
	      : 0;
	    return Math.max(0, contentEngagementState.activeTimeMs + currentSlice);
	  }

	  function getTrackedContentMetaForNode(node) {
	    if (!node || !(node instanceof Element)) return null;
	    var trackedElement = node.closest('[data-evo-content-track]');
	    return trackedElement ? trackedElement.__evoContentMeta || null : null;
	  }

	  function classifyContentDestination(target) {
	    var href = target && target.getAttribute ? target.getAttribute('href') || '' : '';
	    var opensNewTab = target && target.getAttribute && target.getAttribute('target') === '_blank';
	    if (!href) {
	      return {
	        navigation_intent: 'in_page_action',
	        target_type: 'action',
	        target_domain: '',
	        target_path: '',
	        opens_new_tab: false
	      };
	    }
	    if (href.charAt(0) === '#') {
	      return {
	        navigation_intent: 'in_page_navigation',
	        target_type: 'anchor',
	        target_domain: '',
	        target_path: href,
	        opens_new_tab: false
	      };
	    }
	    if (/^(mailto|tel):/i.test(href)) {
	      return {
	        navigation_intent: 'contact',
	        target_type: 'contact',
	        target_domain: '',
	        target_path: '',
	        opens_new_tab: opensNewTab
	      };
	    }

	    try {
	      var url = new URL(href, window.location.href);
	      var sameOrigin = url.origin === window.location.origin;
	      var targetType = 'internal';
	      if (!sameOrigin) targetType = /(^|\.)reddit\.com$/i.test(url.hostname) ? 'reddit' : 'external';
	      else if (/\/checkout(?:\/|$)/.test(url.pathname)) targetType = 'checkout';
	      else if (/\/cart(?:\/|$)/.test(url.pathname)) targetType = 'cart';
	      else if (/\/products\//.test(url.pathname)) targetType = 'product';
	      else if (/\/collections\//.test(url.pathname)) targetType = 'collection';
	      else if (/\/pages\//.test(url.pathname)) targetType = 'page';
	      return {
	        navigation_intent: opensNewTab ? targetType + '_new_tab' : targetType + '_navigation',
	        target_type: targetType,
	        target_domain: sameOrigin ? 'evolova.com' : url.hostname,
	        target_path: truncateParam(url.pathname, 120),
	        opens_new_tab: opensNewTab
	      };
	    } catch (error) {
	      return {
	        navigation_intent: 'unknown_link',
	        target_type: 'unknown',
	        target_domain: '',
	        target_path: '',
	        opens_new_tab: opensNewTab
	      };
	    }
	  }

	  function trackContentInteraction(target) {
	    var meta = getTrackedContentMetaForNode(target);
	    if (!meta) return;
	    var destination = classifyContentDestination(target);
	    var interactionType = target.matches('a') ? 'link_click' : 'button_click';
	    var interactionKey = [
	      'content-interaction',
	      meta.content_id,
	      interactionType,
	      destination.target_type,
	      destination.target_path
	    ].join(':');
	    contentEngagementState.lastInteractionType = interactionType;
	    contentEngagementState.lastInteractionContentId = meta.content_id;
	    contentEngagementState.lastInteractionAt = Date.now();
	    contentEngagementState.navigationIntent = destination.navigation_intent;
	    contentEngagementState.exitTargetType = destination.target_type;
	    contentEngagementState.exitTargetDomain = destination.target_domain;
	    contentEngagementState.exitTargetPath = destination.target_path;
	    if (dedupe(interactionKey, 800)) return;
	    sendContentPathEvent('content_click', meta, {
	      action_type: interactionType,
	      destination_type: destination.target_type
	    });
	  }

	  function trackContentDetailsToggle(details) {
	    if (!details) return;
	    var meta = getTrackedContentMetaForNode(details);
	    if (!meta) return;
	    var interactionType = details.open ? 'details_open' : 'details_close';
	    var interactionKey = 'content-details:' + meta.content_id + ':' + interactionType;
	    contentEngagementState.lastInteractionType = interactionType;
	    contentEngagementState.lastInteractionContentId = meta.content_id;
	    contentEngagementState.lastInteractionAt = Date.now();
	    contentEngagementState.navigationIntent = 'in_page_action';
	    contentEngagementState.exitTargetType = 'action';
	    contentEngagementState.exitTargetDomain = '';
	    contentEngagementState.exitTargetPath = '';
	    if (dedupe(interactionKey, 800)) return;
	    sendContentPathEvent('content_click', meta, {
	      action_type: interactionType,
	      destination_type: 'action'
	    });
	  }

	  function buildContentSummary(signal) {
	    updateScrollDepthCheckpoints();
	    scanVisibleContentFallback(contentEngagementState.candidates);
	    var lastIndex = contentEngagementState.viewedList.length - 1;
	    var lastContent =
	      contentEngagementState.currentContentMeta ||
	      contentEngagementState.viewedList[lastIndex] ||
	      {};
	    var lastEngagedContent = contentEngagementState.lastEngagedContentMeta || {};
	    return {
	      last_content_id: lastContent.content_id,
	      last_engaged_content_id: lastEngagedContent.content_id,
	      max_scroll_depth: contentEngagementState.maxScrollDepth,
	      page_duration_ms: Math.max(0, Date.now() - contentEngagementState.startedAt),
	      exit_signal: signal,
	      last_atc_status: contentEngagementState.lastAtcStatus,
	      transport_type: 'beacon'
	    };
	  }

	  function sendContentExit(signal) {
	    if (contentEngagementState.exitSent) return;
	    contentEngagementState.exitSent = true;
	    pauseContentActiveTime();
	    var summary = buildContentSummary(signal || 'pagehide');
	    sendContentPathEvent('page_exit', {}, summary);
	  }

	  function scanVisibleContentFallback(candidates) {
	    var bestElement = null;
	    var bestScore = -1;
	    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
	    candidates.forEach(function (element) {
	      var rect = element.getBoundingClientRect();
	      var visibleHeight = Math.max(0, Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0));
	      if (!visibleHeight) return;
	      var ratio = Math.max(0, Math.min(1, visibleHeight / Math.max(1, rect.height)));
	      scheduleContentThreshold(element, ratio);
	      var containsCenter = rect.top <= viewportHeight / 2 && rect.bottom >= viewportHeight / 2;
	      var score = visibleHeight + (containsCenter ? viewportHeight : 0);
	      if (score > bestScore) {
	        bestElement = element;
	        bestScore = score;
	      }
	    });
	    if (bestElement) setCurrentContent(bestElement);
	  }

	  function observeContentElement(element) {
	    if (!element || !contentEngagementState.observer) return;
	    contentEngagementState.observer.observe(element);
	  }

	  function refreshContentCandidates() {
	    if (!contentEngagementState.initialized) return;
	    var candidates = getContentCandidates();
	    contentEngagementState.candidates = candidates;
	    candidates.forEach(function (element, index) {
	      element.__evoContentMeta = buildContentMeta(element, index);
	      observeContentElement(element);
	    });
	    scanVisibleContentFallback(candidates);
	  }

	  function scheduleContentRefresh() {
	    if (contentEngagementState.refreshTicking) return;
	    contentEngagementState.refreshTicking = true;
	    window.requestAnimationFrame(function () {
	      contentEngagementState.refreshTicking = false;
	      refreshContentCandidates();
	    });
	  }

	  function resetContentPageInstance() {
	    pageInstanceId = createPageInstanceId();
	    clearContentTimers();
	    contentEngagementState.exitSent = false;
	    contentEngagementState.startedAt = Date.now();
	    contentEngagementState.activeStartedAt = Date.now();
	    contentEngagementState.activeTimeMs = 0;
	    contentEngagementState.maxScrollDepth = 0;
	    contentEngagementState.depthCheckpoints = {};
	    contentEngagementState.viewedById = {};
	    contentEngagementState.impressedById = {};
	    contentEngagementState.engagedById = {};
	    contentEngagementState.exitedById = {};
	    contentEngagementState.viewedList = [];
	    contentEngagementState.currentContentMeta = null;
	    contentEngagementState.previousContentMeta = null;
	    contentEngagementState.lastEngagedContentMeta = null;
	    contentEngagementState.currentContentStartedAt = Date.now();
	    contentEngagementState.navigationIntent = 'none';
	    contentEngagementState.exitTargetType = 'none';
	    contentEngagementState.exitTargetDomain = '';
	    contentEngagementState.exitTargetPath = '';
	    contentEngagementState.lastInteractionType = 'none';
	    contentEngagementState.lastInteractionContentId = '';
	    contentEngagementState.lastInteractionAt = 0;
	    contentEngagementState.isActive = document.visibilityState !== 'hidden';
	    refreshContentCandidates();
	  }

	  function initContentEngagementTracking() {
	    if (contentEngagementState.initialized || !document.body) return;
	    contentEngagementState.initialized = true;
	    contentEngagementState.startedAt = Date.now();
	    contentEngagementState.activeStartedAt = Date.now();
	    contentEngagementState.activeTimeMs = 0;
	    contentEngagementState.isActive = document.visibilityState !== 'hidden';
	    var candidates = getContentCandidates();
	    contentEngagementState.candidates = candidates;
	    candidates.forEach(function (element, index) {
	      element.__evoContentMeta = buildContentMeta(element, index);
	    });
	    updateScrollDepthCheckpoints();
	
	    if ('IntersectionObserver' in window) {
	      contentEngagementState.observer = new IntersectionObserver(
	        function (entries) {
	          entries.forEach(function (entry) {
	            var ratio = entry.isIntersecting ? entry.intersectionRatio : 0;
	            scheduleContentThreshold(entry.target, ratio);
	            if (ratio >= 0.25) {
	              setCurrentContent(entry.target);
	            }
	          });
	        },
	        { threshold: [0, 0.25, 0.5, 0.75], rootMargin: '0px 0px -10% 0px' }
	      );
	      candidates.forEach(function (element) {
	        contentEngagementState.observer.observe(element);
	      });
	    } else {
	      scanVisibleContentFallback(candidates);
	      window.addEventListener('scroll', function () {
	        scanVisibleContentFallback(candidates);
	      }, { passive: true });
	    }
	
	    window.addEventListener('scroll', scheduleScrollDepthCheck, { passive: true });
	    if ('MutationObserver' in window) {
	      contentEngagementState.mutationObserver = new MutationObserver(scheduleContentRefresh);
	      contentEngagementState.mutationObserver.observe(document.body, { childList: true, subtree: true });
	    }
	    document.addEventListener('shopify:section:load', scheduleContentRefresh);
	    window.addEventListener('pagehide', function () {
	      sendContentExit('pagehide');
	    });
	    window.addEventListener('pageshow', function (event) {
	      if (!event.persisted) return;
	      resetContentPageInstance();
	    });
	    document.addEventListener('visibilitychange', function () {
	      if (document.visibilityState === 'hidden') sendContentExit('visibility_hidden');
	      else if (contentEngagementState.exitSent) resetContentPageInstance();
	      else resumeContentActiveTime();
	    });
	    window.setTimeout(function () {
	      scanVisibleContentFallback(candidates);
	    }, 800);
	  }
	
	  function primeCartWhenRelevant() {
	    if (
	      document.querySelector('cart-drawer, cart-items-component, .cart__checkout-button, [name="checkout"]') ||
      document.body.classList.contains('template-cart')
    ) {
      fetchCart();
    }
  }

  document.addEventListener(
    'pointerdown',
    function (event) {
      var eventTarget = event.target instanceof Element ? event.target : event.target?.parentElement;
      var target = eventTarget?.closest('button, a, input[type="submit"]');
      if (!target) return;
      var label = (target.textContent || target.value || target.getAttribute('aria-label') || '').trim();
      if (/add\s*to\s*cart/i.test(label) || target.classList.contains('add-to-cart-button')) {
	        var form = getFormForTarget(target);
	        if (!form || !/\/cart\/add/.test(form.action || '')) return;
	        if (isManagedProductForm(form)) return;
	        trackAddToCartClick(form, target, 'pointerdown');
	      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
	      var form = event.target;
	      if (!form || !/\/cart\/add/.test(form.action || '')) return;
	      if (isManagedProductForm(form)) return;
	      trackAddToCartClick(form, event.submitter || form.querySelector('[type="submit"]'), 'submit');
	    },
    true
  );

	  document.addEventListener(
	    'click',
    function (event) {
	      var eventTarget = event.target instanceof Element ? event.target : event.target?.parentElement;
	      var target = eventTarget?.closest('button, a, input[type="submit"]');
	      if (!target) return;
	      trackContentInteraction(target);

	      var label = (target.textContent || target.value || target.getAttribute('aria-label') || '').trim();
      var href = target.getAttribute('href') || '';
      var name = target.getAttribute('name') || '';

      if ((/checkout/i.test(label) || name === 'checkout' || /\/checkout/.test(href)) && !target.matches('[disabled], [aria-disabled="true"]')) {
        trackCheckoutHandoff({
          target: target,
          source: 'checkout_click',
          sourceArea: getSourceArea(target, null)
        });
      }

      var productLink = target.closest('a[href*="/products/"]');
      if (productLink) {
        var productUrl = productLink.getAttribute('href') || '';
        var handle = productHandleFromUrl(productUrl);
        var listName = getListName(productLink, null);
        var listId = getListId(productLink, null);
        var position = getCardPosition(productLink, null);
        var title = getDataValue(productLink, 'productTitle') || productLink.getAttribute('aria-label') || productLink.textContent || handle;
        var productId = getDataValue(productLink, 'productId');
        var key = 'select-item:' + handle + ':' + listId + ':' + (position || '');
        if (handle && !dedupe(key, 1500)) {
          sendGtag('select_item', {
            item_list_name: listName,
            item_list_id: listId,
            source_area: getSourceArea(productLink, null),
            product_id: productId,
            product_handle: handle,
            items: [
              {
                item_id: productId || handle,
                item_name: String(title || '').trim(),
                item_brand: 'Evolova',
                item_category: 'product',
                item_list_name: listName,
                item_list_id: listId,
                index: position
              }
            ]
          });
        }
      }
    },
	    true
	  );

	  document.addEventListener(
	    'toggle',
	    function (event) {
	      var details = event.target;
	      if (details instanceof HTMLDetailsElement) trackContentDetailsToggle(details);
	    },
	    true
	  );

  document.addEventListener('evolova:cart-add-click', function (event) {
    trackAddToCartClick(event.detail?.form || null, event.detail?.target || null, 'evolova_event', event.detail || {});
  });

  document.addEventListener('evolova:cart-add-success', function (event) {
    trackAddToCartSuccess(event.detail || {});
  });

  document.addEventListener('evolova:cart-add-error', function (event) {
    trackAddToCartError(event.detail || {});
  });

  document.addEventListener('evolova:checkout-handoff', function (event) {
    trackCheckoutHandoff(event.detail || {});
  });

  document.addEventListener('evolova:cart-drawer-open', function (event) {
    trackCartDrawerOpen(event.detail || {});
  });

	  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
	    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
	      if (!shouldTrackPubSubCartUpdate(event)) return;
	      trackAddToCartSuccess({
	        response: event.cartData,
	        variantId: event.productVariantId,
	        source: event.source || 'cart_update',
	        sourceArea: event.sourceArea || 'product_form',
	        actionId: event.actionId,
	        attemptId: event.attemptId || event.actionId || '',
	        trackingSource: 'pubsub_cart_update',
	        fallbackReason: event.__evoFallbackReason || 'explicit_cart_update'
	      });
	    });

    subscribe(PUB_SUB_EVENTS.cartError, function (event) {
      trackAddToCartError({
        variantId: event?.productVariantId,
        response: event,
        reason: event?.message || event?.errors || 'cart_error',
        sourceArea: event?.sourceArea || 'product_form'
      });
    });

    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function (event) {
      var target = event?.data?.target;
      if (!target) return;
      var optionName =
        target.name ||
        target.closest?.('fieldset')?.querySelector('legend')?.textContent ||
        target.closest?.('.product-form__input')?.querySelector('.form__label')?.textContent ||
        'option';
      pendingVariantSelection = {
        optionName: String(optionName).trim(),
        optionValue: String(target.value || '').trim(),
        sourceArea: getSourceArea(target, null),
        time: Date.now()
      };

      window.setTimeout(function () {
        if (!pendingVariantSelection || Date.now() - pendingVariantSelection.time > 1500) return;
        var pending = pendingVariantSelection;
        pendingVariantSelection = null;
        var form = target.closest('product-info')?.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
        sendGtag('variant_select', {
          product_handle: productHandleFromUrl(),
          variant_id: String(getFormDataValue(form, 'id') || ''),
          option_name: pending.optionName,
          option_value: pending.optionValue,
          source_area: pending.sourceArea
        });
      }, 1200);
    });

    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      trackVariantSelectFromPending(event?.data?.variant);
    });
  }

	  if (document.readyState === 'loading') {
	    document.addEventListener('DOMContentLoaded', primeCartWhenRelevant, { once: true });
	    document.addEventListener('DOMContentLoaded', initContentEngagementTracking, { once: true });
	  } else {
	    primeCartWhenRelevant();
	    initContentEngagementTracking();
	  }
	})();
